import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import React, { useState } from 'react';
import { getOnlyData } from '../../utils';
import dayjs from 'dayjs';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import CustomDateTimePicker from '../forms/theme-elements/CustomDateTimePicker';

export default function CusDateTimePicker({
  value,
  time,
  onChange,
  label,
  errorText = '',
  formatChange = 'YYYY-MM-DD HH:mm',
  disabled,
  startDateForError,
  clearable
}) {
  const { t } = useTranslation();
  const defaultInputSize = useAppSelector((state) => state.customizer.inputSize);
  const [open, setOpen] = useState(false);

  const errorStartEnd =
    startDateForError && value && new Date(value).getTime() < new Date(startDateForError).getTime()
      ? t('End date must be later than start date')
      : '';
  const myErrorText = errorText || (startDateForError ? errorStartEnd : '');

  return (
    <CustomDateTimePicker
      label={t(label)}
      format="DD.MM.YYYY HH:mm"
      value={value ? dayjs(value) : null}
      onChange={(newValue) => {
        onChange(newValue ? getOnlyData(newValue, time, formatChange) : null);
        // setOpen(false);
      }}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      closeOnSelect={true}
      disabled={disabled}
      slotProps={{
        textField: {
          onClick: value ? undefined : () => setOpen(true),
          size: defaultInputSize,
          label: t(label),
          fullWidth: true,
          error: !!myErrorText,
          helperText: myErrorText,
          sx: { '& input': { paddingRight: '0' } },
          clearable: clearable,
          InputLabelProps: { shrink: true },
          placeholder: ''
        }
      }}
    />
  );
}
